import React from "react";

const CredentialsContext = React.createContext("");

export default CredentialsContext;

